<template>
    <v-dialog
        :value="dialog"
        persistent
        max-width="400px"
        overlay-color="#909090"
        overlay-opacity="1"
    >
        <v-card>
            <v-card-text class="pa-3 px-6">
                <h2 class="font-weight-bold primary--text my-5">
                    Select your gender
                </h2>

                    <v-form
                        class="text-center"
                        validate-on-blur
                        @keyup.enter="submit"
                        ref="form"
                        @submit.prevent="submit"
                    >
                        <v-radio-group
                            v-model="gender"
                            v-validate="'required'"
                            name="gender"
                            :error-messages="errors.first('gender')"
                            validate-on-blur
                            aria-required
                            required
                        >
                            <v-radio
                                label="Male"
                                value="male"
                            ></v-radio>
                            <v-radio
                                label="Female"
                                value="Female"
                            ></v-radio>
                        </v-radio-group>

                        <div class="text-center my-4">
                            <v-btn
                                class="text--white text-capitalize py-5 title"
                                color="primary"
                                dark
                                block
                                elevation="2"
                                depressed
                                @click.prevent="submit"
                            >
                                Submit
                            </v-btn>
                        </div>
                    </v-form>
            </v-card-text>
        </v-card>
        <loading-overlay :loading="loading" />
    </v-dialog>
</template>

<!-- userGenderDialog -->

<script>
export default {
    data() {
        return {
            dialog: false,
            loading: false,
            resolve: () => {},
            gender: null,
            userId: null,
            token: null,
        };
    },
    methods: {
        show(userId, token) {
            this.dialog = true;
            this.userId = userId;
            this.token = token;

            return new Promise((resolve) => {
                this.resolve = resolve;
                // this.reject = reject;
            });
        },
        async submit() {
            const formIsValid = await this.$validator.validateAll();

            if (formIsValid) {
                try {
                    this.loading = true;
                    await Vue.backendApi().user(this.userId)
                        .storeUser({
                            gender: this.gender,
                        }, {
                            'Authorization': `Bearer ${this.token.access_token}`,
                        });

                    this.dialog = false;
                    this.loading = false;
                    this.resolve({});
                } catch (err) {
                    this.loading = false;
                    this.$swal({
                        type: 'error',
                        title: 'Something went wrong',
                        text: err,
                    });
                }
            }
        },
    },
};
</script>
